// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createStyleSheet } from 'jss-theme-reactor';
import context from '../util/context';

export const displayName = 'ModalSheetHeaderTitle';

export const styleSheet = createStyleSheet(displayName, () => ({
  root: {
    flex: 1,
    color: 'black',
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    textRendering: 'optimizeLegibility',
    display: 'box',
    lineClamp: 2,
    boxOrient: 'vertical',
    overflow: 'hidden'
  }
}));

const parseMinorTitle = (title: string): string =>
  title.split(/\s+\|\s+/).pop();

type State = {
  title?: string
};

export default class ModalSheetHeaderTitle extends Component<*, State> {
  static displayName = displayName;

  state = {};
  observer = null;

  componentDidMount() {
    const { document, MutationObserver } = context;

    if (!document) return;

    const head = document.querySelector('head');
    const title = document.querySelector('title');

    if (!head || !title) return;

    this.setState({
      title: parseMinorTitle(title.innerText || title.innerHTML || '')
    });

    if (!MutationObserver) return;

    this.observer = new MutationObserver(mutations => {
      const [target] = mutations;
      const node = document.querySelector('title');
      if (typeof target === 'object' && typeof node === 'object') {
        this.setState({
          title: parseMinorTitle(node.innerText || node.innerHTML || '')
        });
      }
    });
    this.observer.observe(head, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  componentWillUnmount() {
    if (this.observer && typeof this.observer.disconnect === 'function') {
      this.observer.disconnect();
    }
  }

  static contextTypes = {
    styleManager: PropTypes.object.isRequired
  };

  render() {
    const { title } = this.state;
    const classes = this.context.styleManager.render(styleSheet);

    return <h1 className={classes.root}>{title}</h1>;
  }
}



// WEBPACK FOOTER //
// ./js/ModalSheet/ModalSheetHeaderTitle.js